import { render } from "./PaisForm.vue?vue&type=template&id=8fce6516&scoped=true"
import script from "./PaisForm.vue?vue&type=script&lang=js"
export * from "./PaisForm.vue?vue&type=script&lang=js"

import "./PaisForm.vue?vue&type=style&index=0&id=8fce6516&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fce6516"]])

export default __exports__